// extracted by mini-css-extract-plugin
module.exports = {"controls":"editorTrimControls_controls__3INUG","editorSave":"editorTrimControls_editorSave__mxTxW"};